import { getHostApiBaseUrl } from "../config/env";
import type { AsyncConfig } from "../components/FormRenderer/types";
import type { TaskTableField } from "../types/manualAssessmentWorkflow";

/** Normalize task-table field asyncConfig (same rules as dynamic form). */
export function normalizeTaskTableAsyncConfig(
  field: TaskTableField | undefined,
): AsyncConfig | undefined {
  const raw = field?.asyncConfig as AsyncConfig | undefined;
  if (!raw?.url) return undefined;

  const url = raw.url;
  if (url.includes("/knowledge_manager/concepts/global_filter_search")) {
    return { ...raw };
  }

  if (!url.startsWith("/pm/")) {
    return raw;
  }

  return {
    ...raw,
    basicUrl:
      typeof raw.basicUrl === "string" && raw.basicUrl.length > 0
        ? raw.basicUrl
        : getHostApiBaseUrl(),
  };
}

export function taskTableFieldHasAsyncOptions(
  field: TaskTableField | undefined,
): boolean {
  return Boolean(normalizeTaskTableAsyncConfig(field)?.url);
}
